module.exports = __webpack_public_path__ + "static/media/privilege03.6c0f9b8b.png";